import type {} from '@tanstack/query-core';
import type {} from '@tanstack/react-query';
import type {} from 'jotai/utils';
import { useMember } from './Api/Member';
import { useGnaviWidth } from './Gnavi/gnaviWidth';
import { useIsGnaviPinned } from './Gnavi/isGnaviPinned';

export { AuthInfo } from './model/authInfo';

export const api = { useMember: useMember };
export const gnavi = { useIsGnaviPinned, useGnaviWidth };
